import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "nameButton"]

  connect() {
    this.nameDirection = "asc"
  }

  sortByName(event) {
    event.preventDefault()

    const direction = this.nameDirection
    const rows = Array.from(this.bodyTarget.querySelectorAll("tr"))

    rows.sort((left, right) => {
      const leftName = left.dataset.name || ""
      const rightName = right.dataset.name || ""
      const result = leftName.localeCompare(rightName, undefined, { sensitivity: "base" })
      return direction === "asc" ? result : -result
    })

    rows.forEach((row) => this.bodyTarget.appendChild(row))
    this.nameDirection = direction === "asc" ? "desc" : "asc"
    this.nameButtonTarget.setAttribute("aria-sort", direction === "asc" ? "ascending" : "descending")
  }
}
